import { PageHero } from "../components/layout/PageHero";
import type { Vertical } from "../types/vertical";
import { NotFoundPage } from "./NotFoundPage";

export function FutureVerticalPage({ vertical }: { vertical: Vertical | undefined }) {
  if (!vertical) {
    return <NotFoundPage />;
  }

  return (
    <PageHero
      eyebrow={vertical.status}
      title={`${vertical.title} entra com dor própria, não como cópia de Beauty.`}
      text={`${vertical.promise} Esta rota existe para preparar descoberta, lista de interesse e validação sem prometer disponibilidade comercial plena antes da hora.`}
      primary={{ href: "/go", label: "Conhecer THH GO" }}
      secondary={{ href: "/beauty", label: "Ver primeira vertical" }}
    />
  );
}
